import React from 'react'
import { graphql, Link } from 'gatsby'
import { useI18next } from 'gatsby-plugin-react-i18next';
import Layout from '../components/layout'
import Row from '../components/primitives/row'
import Text from '../components/primitives/text'
import Spacing from '../components/primitives/spacing'
import Seo from '../components/seo';

const NotFoundPage = ({ data }) => {
  const { footer } = data
  const { languages, originalPath, t, i18n } = useI18next();
  return (
    <Layout
      pageTitle="Not Found"
      pageDescription="The page you're looking for has been moved"
      footer={footer}
      t={t}
      languages={languages}
      i18n={i18n}
      originalPath={originalPath}
    >
      <Spacing margin={{ t: 8 }}>
        <Row>
          <Text type="h1" text="Not found" />
        </Row>
      </Spacing>
      <Spacing margin={{ t: 8 }}>
        <Row>
          <Text type="body">
            The page you&#39;re looking for has been (re)moved. You can return to
            {' '}
            <Link to="/">home</Link>
            .
          </Text>
        </Row>
      </Spacing>
    </Layout>
)
}


export const query = graphql`
  query( 
    $language: String!
  ) {
    locales: allLocale(
      filter: { ns: { in: ["common"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }  
    footer: footerJson(language: { eq: $language }) {
      language
      copyright
      cookie{
        text
        buttonText
      }
      socials {
        title
        slug
      }
      support {
        title
        slug
      }
      about {
        title
        slug
      }
    }
  }
`

export default NotFoundPage


export const Head = () => <Seo title="404: Not Found" />

